import React, { useState } from 'react';
import { Collapse, ListGroupItem } from 'shards-react';
import QaItemAdditional from './QaItemAdditional';
import type { Language } from '../../../types/common';
import type { QaItem } from '../../../types/qa';

interface QaListItemProps {
  language: Language;
  item: QaItem;
}

const QaListItem = ({ language, item }: QaListItemProps): React.ReactElement => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log(selectedTab);
  // }, [selectedTab]);

  // EVENT HANDLER
  // ================================================================================

  const handleToggle = (): void => {
    setIsCollapsed(!isCollapsed);
  };

  // VIEW
  // ================================================================================

  return (
    <ListGroupItem>
      <div className="d-flex align-items-center my-2" onClick={handleToggle} style={{ cursor: 'pointer' }}>
        <span className="material-icons mr-1">{item.icon}</span>
        <span className="font-weight-bold">{item.question[language]}</span>
        <span className="material-icons ml-2">{isCollapsed ? 'expand_more' : 'expand_less'}</span>
      </div>
      <Collapse open={!isCollapsed} className="ml-2 mb-2">
        <div style={{ whiteSpace: 'pre-line' }}>{item.answer[language]}</div>
        {item.additional && <QaItemAdditional language={language} additional={item.additional} />}
      </Collapse>
    </ListGroupItem>
  );
};

export default QaListItem;
